import { Card, CardContent } from '@mui/material'
import { useParams } from 'react-router-dom'
import { LXLoader } from '../../components/LXLoader'
import { NewPromotionOperation } from '../../components/VideosPromotions/NewPromotionOperation'
import { VideoPromotionDetail } from '../../components/VideosPromotions/VideoPromotionDetail'
import { VideoPromotionHelper } from '../../helpers/VideoPromotion.helper'
import styles from './VideosPromotions.module.scss'

export const VideoPromotion = () => {
  const params = useParams()

  if (!params) {
    return <LXLoader />
  }

  if (params.videoPromotionId === VideoPromotionHelper.NEW_OPERATION) {
    return (
      <Card sx={{ overflow: 'visible' }}>
        <CardContent className={styles.container}>
          <NewPromotionOperation />
        </CardContent>
      </Card>
    )
  }

  if (params.videoPromotionId) {
    return (
      <Card>
        <CardContent className={styles.container}>
          <VideoPromotionDetail operationId={params.videoPromotionId} />
        </CardContent>
      </Card>
    )
  }
}
